import React from "react";
import {
    IPsoWorkerAgreementViewModel
} from "../../../../services/booking/models/pso/agreements/workers/pso-worker-agreement.view-model.interface";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {
    FieldsContainerBox,
    FullGridLineBox,
    SectionTitleBox
} from "../common/boxes/pso-agreement.boxes";
import {
    DateFieldEditorWithInputMaskComponent,
    DateFieldMask
} from "../../../forms/date-time/date-field-editor-with-input-mask.component";
import {StringFieldEditorComponent} from "../../../forms/string-field/string-field-editor.component";
import {PhoneNumberInputComponent} from "../../../forms/contact/phone-number-input.component";
import {EmailFieldEditorComponent} from "../../../forms/contact/email-field-editor.component";

export const PsoWorkerAgreementComponent: React.FC<{workerAgreement: IPsoWorkerAgreementViewModel;}> = observer((props) => {
    const services = useServices();

    const fields = props.workerAgreement.fields;
    return (
        <FieldsContainerBox>
            <SectionTitleBox>
                {services.language.translate(`Personal details`)}
            </SectionTitleBox>
            <DateFieldEditorWithInputMaskComponent field={fields.dateOfBirth} mask={DateFieldMask.DDMMYYYY} />
            <StringFieldEditorComponent field={fields.birthLocation}/>
            <StringFieldEditorComponent field={fields.residenceLocation}/>
            <StringFieldEditorComponent field={fields.fiscalCode}/>
            <PhoneNumberInputComponent field={fields.phoneNumber}/>
            <EmailFieldEditorComponent field={fields.email}/>

            <SectionTitleBox>
                {services.language.translate('Employment details')}
            </SectionTitleBox>

            <FullGridLineBox>
                <StringFieldEditorComponent field={fields.jobTitle}/>
            </FullGridLineBox>
            <FullGridLineBox>
                <StringFieldEditorComponent field={fields.employerCompanyName}/>
            </FullGridLineBox>
            <PhoneNumberInputComponent field={fields.employerCompanyPhone}/>
            <EmailFieldEditorComponent field={fields.employerCompanyEmail}/>

            <SectionTitleBox>
                {services.language.translationFor('Details of the activity to be performed in {region}').withParams({region: props.workerAgreement.marketNameTranslation})}
            </SectionTitleBox>

            <FullGridLineBox>
                <StringFieldEditorComponent field={fields.workActivityDescription}/>
            </FullGridLineBox>

            <StringFieldEditorComponent field={fields.workLocationCompanyName}/>
            <StringFieldEditorComponent field={fields.workLocationCompanyAddress}/>

            <PhoneNumberInputComponent field={fields.workLocationCompanyPhone}/>
            <EmailFieldEditorComponent field={fields.workLocationCompanyEmail}/>

            <DateFieldEditorWithInputMaskComponent field={fields.workFromDate} mask={DateFieldMask.DDMMYYYY} />
            <DateFieldEditorWithInputMaskComponent field={fields.workUntilDate} mask={DateFieldMask.DDMMYYYY} />

        </FieldsContainerBox>
    );
})